module.exports = __webpack_public_path__ + "assets/text-icon.0263376a.svg";